import callAPiBase from './base';

const conversationReplyChartApi = {
  list: ({ startDate, endDate }: { startDate: number, endDate: number }) =>
    callAPiBase({
      endpoint: `/api/reports/conversation/reply?startDate=${startDate}&endDate=${endDate}`,
      method: 'GET',
      useToken: true,
    }),
};

export { conversationReplyChartApi };
export default conversationReplyChartApi;
